var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIconCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFDEE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2086 25.7961C23.0245 20.8133 24.4325 18.3219 26.3646 17.6806C27.4274 17.3278 28.5724 17.3278 29.6353 17.6806C31.5673 18.3219 32.9753 20.8133 35.7913 25.7961C38.6072 30.7789 40.0152 33.2702 39.5928 35.3003C39.3605 36.417 38.788 37.43 37.9575 38.194C36.4478 39.5827 33.6318 39.5827 27.9999 39.5827C22.368 39.5827 19.5521 39.5827 18.0424 38.194C17.2118 37.43 16.6394 36.417 16.407 35.3003C15.9846 33.2702 17.3926 30.7789 20.2086 25.7961Z",
    stroke: "#DF0C3D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9905 33.166H28.001",
    stroke: "#DF0C3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29.666L28 24.9993",
    stroke: "#DF0C3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIconCircle);
export default __webpack_public_path__ + "static/media/alert-icon-circle.79bd66ff44ebaa8e6bfab71d72f0bb06.svg";
export { ForwardRef as ReactComponent };